import { returnErrors } from './errorAction';
import { GET_PLANS, GET_ACCOUNT_DETAIL, VALIDATE_COUPON_CODE, APPLY_CODE, UPDATE_PROFILE, GET_COMPANIES, CREATE_COMPANY, UPDATE_COMPANY_STATUS, UPDATE_COMPANY, GET_COMPANY_MEMBERS, ADD_COMPANY_MEMBER, UPDATE_MEMBER_PERMISSIONS, UPDATE_MEMBER_STATUS, GET_MEMBER_BY_ID, GET_COMPANY_ROLES, GET_MODULES } from '../Types/types';
import { getApiCall, handle403Logout, postApiCall, patchApiCall, deleteApiCall } from '../../utils/request';
import { deleteJobApiCall, getJobApiCall, patchJobApiCall, postJobApiCall, putJobApiCall } from '../../utils/jobRequest';


export const getAccountDetail = () => async (dispatch) => {
    try {
        const response = await getApiCall(`setting/account-details`);
        if (response?.status === 200) {
            return dispatch({ type: GET_ACCOUNT_DETAIL, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const getPlans = () => async (dispatch) => {
    try {
        const response = await getApiCall(`setting/get-payment-plans`);
        if (response?.status === 200) {
            return dispatch({ type: GET_PLANS, payload: response.data.paymentPlans });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const validateCoupon = (code) => async (dispatch) => {
    try {
        const response = await getApiCall(`setting/validate-coupon-code?CouponCode=${code}`);
        if (response?.status === 200) {

            return dispatch({ type: VALIDATE_COUPON_CODE, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const applyCoupon = (code) => async (dispatch) => {
    try {
        const response = await getApiCall(`setting/apply-coupon-code?CouponCode=${code}`);
        if (response?.status === 200) {
            returnErrors(dispatch, 'Coupon applied succesfully', response?.status)
            return dispatch({ type: APPLY_CODE, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const updateCompanyProfile = (obj) => async (dispatch) => {
    const data = new FormData();
    data.append('tenantId', obj?.tenantId);
    obj.image && data.append('file', obj.image);
    try {
        const response = await postApiCall(`setting/update-account-details?DisplayName=${obj.name}&websiteName=${obj.website}&languageId=${obj.languageId}`, data);
        if (response?.status === 200) {
            return dispatch({ type: UPDATE_PROFILE, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const getApiKeys = () => async (dispatch) => {
    try {
        const response = await getJobApiCall(`api-keys/`);
        if (response?.status === 200) {
            return dispatch({ type: 'GET_API_KEYS', payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const createApiKey = (payload) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`api-keys/`, payload);
        if (response?.status === 201) {
            dispatch({ type: 'CREATE_API_KEY', payload: response.data });
            return response.data;
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const revokeApiKey = (id) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`api-keys/${id}/revoke`);
        if (response?.status === 200) {
            return dispatch({ type: 'REVOKE_API_KEY', payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const deleteApiKey = (id) => async (dispatch) => {
    try {
        const response = await deleteJobApiCall(`api-keys/${id}`);
        if (response?.status === 200) {
            return dispatch({ type: 'DELETE_API_KEY', payload: id });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

// ─── Companies ───────────────────────────────────────────────────────────────

export const getCompanies = (limit = 10, page = 1) => async (dispatch) => {
    try {
        const response = await getJobApiCall(`companies/?page_size=${limit}&page=${page}`);
        if (response?.status === 200) {
            return dispatch({
                type: GET_COMPANIES,
                payload: {
                    data: Array.isArray(response.data.data) ? response.data.data : [],
                    total: response.data?.pagination?.total ?? 0,
                },
            });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const createCompany = (payload) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`companies/`, payload);
        if (response?.status === 200 || response?.status === 201) {
            return dispatch({ type: CREATE_COMPANY, payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const updateCompanyStatus = (companyId, isActive) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`companies/${companyId}/status?is_active=${isActive}`);
        if (response?.status === 200 || response?.status === 204) {
            return dispatch({ type: UPDATE_COMPANY_STATUS, payload: { id: companyId, is_active: isActive } });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const updateCompany = (companyId, payload) => async (dispatch) => {
    try {
        const response = await putJobApiCall(`companies/${companyId}`, payload);
        if (response?.status === 200 || response?.status === 204) {
            return dispatch({ type: UPDATE_COMPANY, payload: { id: companyId, ...payload } });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getCompanyById = (companyId) => async (dispatch) => {
    try {
        const response = await getJobApiCall(`companies/${companyId}`);
        if (response?.status === 200) {
            const data = response.data?.data ?? response.data;
            return dispatch({ type: UPDATE_COMPANY, payload: data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

// ─── Company Members ──────────────────────────────────────────────────────────

export const getCompanyMembers = (companyId, pageSize = 10, page = 1) => async (dispatch) => {
    try {
        let url = `company-members?page_size=${pageSize}&page=${page}`;
        if (companyId) {
            url += `&company_id=${companyId}`;
        }
        const response = await getJobApiCall(url);
        if (response?.status === 200) {
            return dispatch({ type: GET_COMPANY_MEMBERS, payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const addCompanyMember = (companyId, payload) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`companies/${companyId}/members`, payload);
        if (response?.status === 200 || response?.status === 201) {
            return dispatch({ type: ADD_COMPANY_MEMBER, payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const getCompanyRoles = (companyId) => async (dispatch) => {
    try {
        const response = await getJobApiCall(`companies/${companyId}/roles`);
        if (response?.status === 200) {
            const roles = Array.isArray(response.data)
                ? response.data
                : Array.isArray(response.data?.data)
                    ? response.data.data
                    : [];
            return dispatch({ type: GET_COMPANY_ROLES, payload: roles });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getModules = () => async (dispatch) => {
    try {
        const response = await getJobApiCall(`modules`);
        if (response?.status === 200) {
            const modules = Array.isArray(response.data)
                ? response.data
                : Array.isArray(response.data?.data)
                    ? response.data.data
                    : [];
            return dispatch({ type: GET_MODULES, payload: modules });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const updateMemberPermissions = (memberId, payload) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`user-management/members/${memberId}/permissions`, payload);
        if (response?.status === 200) {
            return dispatch({ type: UPDATE_MEMBER_PERMISSIONS, payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const updateMemberStatus = (companyUserId, isActive) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`company-members/${companyUserId}/status?is_active=${isActive}`);
        if (response?.status === 200) {
            return dispatch({ type: UPDATE_MEMBER_STATUS, payload: { id: companyUserId, is_active: isActive } });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getMemberById = (companyUserId) => async (dispatch) => {
    try {
        const response = await getJobApiCall(`company-members/${companyUserId}`);
        if (response?.status === 200) {
            const data = response.data?.data ?? response.data;
            return dispatch({ type: GET_MEMBER_BY_ID, payload: data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

// ─── Checkout ─────────────────────────────────────────────────────────────────

export const createCheckout = (planId) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`payments/checkout`, {
            plan_id: planId,
            mode: 'subscription',
            currency: 'USD',
            country: 'US',
            gateway_code: 'paypal',
            idempotency_key: crypto.randomUUID(),
            success_url: window.location.origin + '/billing/success',
            cancel_url: window.location.origin + '/billing/cancel',
        });
        if (response?.status === 200 || response?.status === 201) {
            return dispatch({ type: 'CREATE_CHECKOUT', payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.message || response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const cancelCheckout = (orderId) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`payments/checkout/${orderId}/cancel`);
        if (response?.status === 200 || response?.status === 204) {
            return dispatch({ type: 'CANCEL_CHECKOUT', payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.message || response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const syncCheckout = (orderId) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`payments/checkout/${orderId}/sync-from-gateway`);
        if (response?.status === 200 || response?.status === 201) {
            return dispatch({ type: 'SYNC_CHECKOUT', payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.message || response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}
